export enum UserRole {
  Admin = "ADMIN",
  Customer = "CUSTOMER",
}